import { render, staticRenderFns } from "./demontable.vue?vue&type=template&id=b82424c0&scoped=true"
import script from "./demontable.vue?vue&type=script&lang=js"
export * from "./demontable.vue?vue&type=script&lang=js"
import style0 from "./demontable.vue?vue&type=style&index=0&id=b82424c0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82424c0",
  null
  
)

export default component.exports